import { render, staticRenderFns } from "./MessageHandler.vue?vue&type=template&id=451149ec&"
import script from "./MessageHandler.vue?vue&type=script&lang=js&"
export * from "./MessageHandler.vue?vue&type=script&lang=js&"
import style0 from "./MessageHandler.vue?vue&type=style&index=0&id=451149ec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports